module.exports = __webpack_public_path__ + "assets/3f5500321e14e60ea5c973d163782ea0.png";